/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_Deleted_SuccessInputs */

const en_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD job deleted successfully.`)
};

const fr_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâche AD supprimée avec succès.`)
};

const de_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Auftrag erfolgreich gelöscht.`)
};

const it_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processo AD eliminato correttamente.`)
};

const ru_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задание Active Directory успешно удалено.`)
};

const es_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarea de AD eliminada correctamente.`)
};

const zh_cn2_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD作业已成功删除。`)
};

const ja_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADジョブは正常に削除されました。`)
};

const hi_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD जॉब सफलतापूर्वक डिलीट हो गया।`)
};

const pt_pt2_ad_job_deleted_success = /** @type {(inputs: Ad_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa do AD excluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "AD job deleted successfully." |
*
* @param {Ad_Job_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_deleted_success = /** @type {((inputs?: Ad_Job_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_job_deleted_success(inputs)
	if (locale === "de") return de_ad_job_deleted_success(inputs)
	if (locale === "it") return it_ad_job_deleted_success(inputs)
	if (locale === "ru") return ru_ad_job_deleted_success(inputs)
	if (locale === "es") return es_ad_job_deleted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_job_deleted_success(inputs)
	if (locale === "ja") return ja_ad_job_deleted_success(inputs)
	if (locale === "hi") return hi_ad_job_deleted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_job_deleted_success(inputs)
	return en_ad_job_deleted_success(inputs)
});